/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import {regExp} from 'Src/validation-schemas/Constants'

export const SoftPullFormSchema = ({phoneRequired = false} = {}) =>
  Yup.object().shape({
    firstName: Yup.string()
      .matches(/^([^0-9]*)$/, 'First Name cannot contain numbers.')
      .required('First Name is required.')
      .max(30, 'First Name must be fewer than 100 characters')
      .min(2, 'First Name must be two or more characters'),
    lastName: Yup.string()
      .matches(/^([^0-9]*)$/, 'Last Name cannot contain numbers.')
      .required('Last Name is required.')
      .max(30, 'Last Name must be fewer than 100 characters')
      .min(2, 'Last Name must be two or more characters'),
    address: Yup.string()
      .required('Address is required.')
      .min(3, 'Address must be two or more characters')
      .max(200, 'Address must be fewer than 200 characters'),
    zipCode: Yup.string()
      .required('ZIP code is required.')
      .matches(
        regExp.zipCode,
        'ZIP code is invalid. Entered value must be 5 digits between 0 and 9. For example, 80202.'
      )
      .min(5, 'Please enter a five digit ZIP code.')
      .max(5, 'Please enter a five digit ZIP code.'),
    cityCounty: Yup.object().nullable().required('City/County is required.'),
    email: Yup.string()
      .email('A valid Email address is required')
      .required('Email is required.')
      .max(45, 'Email must be fewer than 100 characters'),
    get phone() {
      const phoneSchema = Yup.string().matches(regExp.phone, 'Phone Number is invalid.').nullable()

      return phoneRequired
        ? phoneSchema.required('Phone Number is required.')
        : phoneSchema.notRequired()
    },
    legalCheckbox: Yup.boolean().oneOf(
      [true],
      'You must agree to the above statement to continue.'
    ),
  })
